import { FC } from 'react';
import AppDarkLogo from '../../icon/AppDarkLogo';
import AppLogo from '../../icon/AppLogo';

const Logo: FC<{ isDark?: boolean }> = ({ isDark = false }) => (
  <div className="logo-image">{isDark ? <AppDarkLogo /> : <AppLogo />}</div>
);

export default Logo;
